import { DemoTemplate } from '../../types';

// 建号提交前二次确认文案：0=不启用；>0=启用某模板。
export function demoConfirmMessage(templateId: number, templates: DemoTemplate[]): string {
  if (templateId === 0) {
    return '确定不启用示例模板？';
  }
  const tpl = templates.find(t => t.id === templateId);
  const label = tpl ? `${tpl.id} - ${tpl.nameTemplate}` : `${templateId}`;
  return `确认使用示例模板 [${label}]？`;
}
